import React from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  bottom: {
    position: 'absolute',
  },
  greyImage: {
    filter: 'grayscale(100%)',
  },
  top: {
    zIndex: 1,
    '& .MuiCircularProgress-svg': {
      'stroke-linecap': 'round',
    },
  },
  pointsProgress: {
    '& .MuiCircularProgress-svg': {
      transform: 'rotate(+10deg)',
    },
  },
}));

interface Props extends CircularProgressProps {
  icon: string;
  iconSize: number;
  trackColor?: string;
  isGreyImage?: boolean;
  isPoints?: boolean;
}

const CircularProgressWithIcon = ({
  icon,
  iconSize,
  trackColor,
  isGreyImage = false,
  isPoints = false,
  ...props
}: Props) => {
  const classes = useStyles();

  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        {...props}
        className={classNames(classes.top, isPoints && classes.pointsProgress)}
      />

      {!!trackColor && (
        <CircularProgress
          {...props}
          value={100}
          className={classes.bottom}
          style={{ color: trackColor }}
        />
      )}

      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={isGreyImage ? classes.greyImage : ''}>
        <img style={{ maxWidth: iconSize, maxHeight: iconSize }} src={icon} alt="Points" />
      </Box>
    </Box>
  );
};

export default CircularProgressWithIcon;
